import * as theme from "../theme";

import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import React from "react";
import styled from "styled-components";
import Button from "../components/CustomButton";
import ErrorMessage from "../components/ErrorMessage";
import HeaderText from "../components/HeaderText";
import InputContainer from "../components/inputs/InputContainer";
import Context from "../contexts/data";
import ageList from "../util/ageList";
import { handleRedirection } from "../util/httpHelpers";
import classes from "./Age.module.css";

const Age = ({ changeHeadline, isPurchase }) => {
  const { age, handleUpdateFormValue, errorMessage, navigate } =
    React.useContext(Context);

  const [buttonText, setButtonText] = React.useState("Next");

  const handleNextStep = () => {
    if (!age) {
      handleUpdateFormValue("errorMessage", "Please select your age.");
      return;
    } else {
      if (age < 62) {
        setButtonText("Redirecting...");
        handleRedirection("age");
      } else {
        navigate("zip-code", "Age");
      }
    }
  };

  const handleSelectAge = ({ target }) => {
    handleUpdateFormValue("age", target.value);
    handleUpdateFormValue("errorMessage", "");
  };

  let headlineText = "Unlock Cash with a Reverse Mortgage — Get Started";
  let subHeadlineText = "See how much you may be eligible for.";

  if (changeHeadline) {
    headlineText = "Start Your Journey Towards A Secure Retirement";
    subHeadlineText = "Access Funds With Ease";
  }

  if (isPurchase) {
    headlineText = "Get Pre-Approved Today!";
  }

  return (
    <Wrapper>
      <HeaderText bigger_text={headlineText} smaller_text={subHeadlineText} />
      <TextContainer>
        <Text>How old is the homeowner?</Text>
      </TextContainer>
      <InputContainer inputClass="genericContainer">
        <Select
          fullWidth
          displayEmpty
          value={age || ""}
          onChange={handleSelectAge}
          error={errorMessage.length > 0}
          helpertext={errorMessage}
          className={classes.customSelect}
        >
          <MenuItem value={""}>Select Age</MenuItem>
          <MenuItem value={61}>Under 62</MenuItem>
          {ageList.map((i) => (
            <MenuItem key={i} value={i}>
              {i}
            </MenuItem>
          ))}
          <MenuItem value={90}>90+</MenuItem>
        </Select>
      </InputContainer>
      <ErrorMessage />
      <Button onClick={handleNextStep} text={buttonText} showContent={true} />
    </Wrapper>
  );
};

const Wrapper = styled(theme.column_align)`
  transform: translateY(0px);
`;

const TextContainer = styled.div``;

const Text = styled.p`
  font-family: "Inter";
  font-style: normal;
  font-weight: 600;
  font-size: 24px;
  line-height: 32px;
  margin-bottom: 0;

  @media (max-width: ${theme.mobile}) {
    font-size: 16px;
  }
`;

export default Age;
